const CLS = {
  Google: "border-sky-500/40 bg-sky-500/10 text-sky-300",
  Meta: "border-indigo-400/40 bg-indigo-400/10 text-indigo-300",
  Email: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  Direct: "border-zinc-500/40 bg-zinc-500/10 text-zinc-300",
  Altele: "border-zinc-700 bg-zinc-800/60 text-zinc-400",
};

export const SOURCE_OPTIONS = ["Google", "Meta", "Email", "Direct", "Altele"];

export const OrderSource = ({ src, testId }) => {
  if (!src?.first) return null;
  const main = src.main || (src.last && src.last !== "Direct" ? src.last : src.first);
  const tip = `Sursă (ultima vizită, fără Direct): ${main}\nPrima vizită: ${src.first}${src.first_detail ? ` (${src.first_detail})` : ""}\nUltima vizită: ${src.last}${src.last_detail ? ` (${src.last_detail})` : ""}${src.sessions ? `\n${src.sessions} sesiuni` : ""}`;
  return (
    <div className="flex flex-col items-start gap-0.5" title={tip} data-testid={testId}>
      <span className={`rounded-full border px-1.5 py-px text-[10px] font-semibold leading-tight ${CLS[main] || CLS.Altele}`} data-testid={`${testId}-main`}>{main}</span>
      {src.first !== main && <span className="text-[9px] text-zinc-500" data-testid={`${testId}-first`}>prima: {src.first}</span>}
    </div>
  );
};
